import React, { Component } from "react";
import { Tag, Icon } from "antd";

const priorities = {
  "0": { label: "Low", color: "#444" },
  "1": { label: "Normal", color: "#6bd222" },
  "2": { label: "High", color: "#D2222D" }
};

class TestCasePriority extends Component {
  render() {
    const style = this.props.style ? this.props.style : {};
    return (
      <span
        style={{
          color: priorities[this.props.priority]
            ? priorities[this.props.priority].color
            : "#444",
          marginLeft: "25px",
          ...style
        }}
      >
        <Icon
          type="exclamation-circle"
          title={`${
            priorities[this.props.priority]
              ? priorities[this.props.priority].label
              : "NA"
          }`}
        />
        &nbsp;
        {this.props.withLabel
          ? priorities[this.props.priority]
            ? priorities[this.props.priority].label
            : "NA"
          : null}
      </span>
    );
  }
}
export default TestCasePriority;
